/** LocalStorage keys used as lightweight guards */
export const DRAFT_KEY = 'eneda_membership_draft_v1';
export const TERMS_STORAGE_KEY = 'eneda_terms_accepted_v1';
export const FLOW_STARTED_KEY = 'eneda_membership_started_v1';
export const FLOW_READY_FOR_PAYMENT_KEY = 'eneda_ready_for_payment_v1';
